import {
  API_ROUTES,
  API_ROUTE_PREFIX,
  IOrderDetailsRequestParams,
  resolveCmpForApiRequest,
} from "@tm/api-utils";
import { LOB } from "@tm/isomorphic-utils";
import {
  getLobOnServerSide,
  getPathPartnerOnServerSide,
} from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

/** Client-only deeplink keys that must not be forwarded to the order-details API. */
const stripClientOnlyQueryParams = (
  query?: IOrderDetailsRequestParams["query"]
) => {
  if (!query) {
    return query;
  }
  const { action: _action, ...rest } = query as Record<string, unknown>;
  return rest as IOrderDetailsRequestParams["query"];
};

export const getOrderDetailsV2 = async (
  data: IOrderDetailsRequestParams
): Promise<any> => {
  try {
    const { partner, bookingId, headers, cmp, query, dvid } = data || {};
    const sanitizedQuery = stripClientOnlyQueryParams(query);
    const headerCmp = resolveCmpForApiRequest(cmp, sanitizedQuery);
    const params = {
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      bookingId,
      ...sanitizedQuery,
    };

    const pathPartner = getPathPartnerOnServerSide(partner);

    const urlParams = setURLQueryParams(params);

    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${pathPartner}/${API_ROUTES.ORDER_DETAIL_V2}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp: headerCmp, dvid },
      }
    );

    return response;
  } catch (error) {
    console.error("Error", { error });
    throw error;
  }
};
